import { render, staticRenderFns } from "./shortMessageTpl.vue?vue&type=template&id=0c494e43&scoped=true&"
import script from "./shortMessageTpl.vue?vue&type=script&lang=js&"
export * from "./shortMessageTpl.vue?vue&type=script&lang=js&"
import style0 from "./shortMessageTpl.vue?vue&type=style&index=0&id=0c494e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c494e43",
  null
  
)

export default component.exports